import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { LocationMap } from './LocationMap';
import type { BookingPageLocation } from '../types';

export function LocationSection({ location }: { location: BookingPageLocation }) {
  const { t } = useTranslation('bookingPage');
  if (location.latitude == null || location.longitude == null) return null;

  const mapsUrl = `https://www.openstreetmap.org/?mlat=${location.latitude}&mlon=${location.longitude}#map=16/${location.latitude}/${location.longitude}`;

  return (
    <section className="flex flex-col gap-4" data-testid="location-section">
      <h2 className="font-display text-[20px] font-semibold tracking-tight text-ink sm:text-[24px]">{t('location.title')}</h2>
      <div className="relative overflow-hidden rounded-2xl border border-line">
        <LocationMap
          latitude={location.latitude}
          longitude={location.longitude}
          label={t('location.mapLabel', { address: location.address })}
          className="h-[220px] w-full sm:h-[300px]"
        />
        <a
          href={location.directions_url || mapsUrl}
          target="_blank"
          rel="noreferrer"
          className="absolute right-4 top-4 z-[500] inline-flex h-10 items-center gap-2 rounded-md border border-line bg-surface px-3.5 text-[14px] font-medium text-brand-500 shadow-sm hover:text-brand-700"
        >
          {t('location.openInMaps')}
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
    </section>
  );
}
